import CityManagementPage from "./shared/CityManagementPage";
import { allCityConfigs } from "./shared/cityConfigExtended";

export default function Stoke() {
  return <CityManagementPage config={allCityConfigs.stoke} />;
}